import React from 'react'
import styled from 'styled-components'

import LoginLoader from './LoginLoader'

const StyledLoginContainer = styled.div`
  margin-left: 200px;
  width: 500px;
  background-color: white;
  padding: 30px;
  padding-top: 10px;
  position: relative;
  overflow: hidden;
  border-radius: 5px;
`

const StyledLogoContainer = styled.div`
  img {
    width: 55%;
    display: block;
    margin: 30px auto 20px;
  }
`

const StyledLogin = styled.div`
  margin-top: 4vh;
  margin-bottom: 4vh;
  height: 92vh;
  background-color: white;
  background-image: url('/static/images/login-background.jpg');
  background-size: cover;
  padding-top: 40px;
`

export default ({ children, handleSubmit, loading, passwordResetForm, showPasswordResetForm, translate }) => (
  <StyledLogin>
    <StyledLoginContainer>
      <LoginLoader loading={loading} />

      <form onSubmit={handleSubmit}>
        <StyledLogoContainer>{children[0]}</StyledLogoContainer>
        {showPasswordResetForm ? (
          passwordResetForm
        ) : (
          <>
            {children[1]}

            <div className="u-flex u-marginBottom-20">
              <div className="u-fluid u-marginRight-10">
                <p className="u-marginBottom-5">{translate('lbl_username')}</p>

                {children[2]}
              </div>

              <div className="u-fluid">
                <p className="u-marginBottom-5">{translate('lbl_password')}</p>

                {children[3]}
              </div>
            </div>

            {children[4]}

            <div>{children[5]}</div>
          </>
        )}
        <div className="u-flex u-flexCenter u-marginTop-20">{children[6]}</div>
      </form>
    </StyledLoginContainer>
  </StyledLogin>
)
